import { SelfTestQuestion, SelfTestQuestionCollection } from "../../../../components/self-test/model/SelfTestQuestion";
import { result } from "./result";

export const questions: SelfTestQuestionCollection = {
    analytics: {
        slug: 'bipolar-disease',
        resultText: (answers) => {
            const r = result(answers);
            return `risk_${r.risk ? 'high' : 'low'}`;
        }   
    },
    showProgressBarAfterIndex: 99,
    questions: [
        {
            type: 'description',
            label: '開始',
            title: '您受躁鬱症困擾嗎？<br/><br/>',
            content: '此測試由美國的五所精神科診所制定並認可，以用作初步評估。只需回答14條簡單選擇題，就可了解自己的情況<sup>5</sup>。<br/><br/><br/>',
            image: 'self-test/bipolar-disease/q0.png',
            btnText: "開始評估",
        },
        {
            type: 'multiple-choice',
            label: '第一題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '1. 非常興奮，連身邊的人也察覺到您和平常不同？',
            image: 'self-test/bipolar-disease/q1.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第二題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '2. 十分煩躁，開始向人發脾氣，發生爭執？',
            image: 'self-test/bipolar-disease/q2.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第三題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '3. 比平時更有自信，認為很多事情也能輕易做到？',
            image: 'self-test/bipolar-disease/q3.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第四題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '4. 睡得比平時少，卻不覺疲勞？',
            image: 'self-test/bipolar-disease/q4.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第五題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '5. 比平時更健談，或說話速度加快？',
            image: 'self-test/bipolar-disease/q5.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第六題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '6. 想到很多事情，或思考速度快得難以停下來？',
            image: 'self-test/bipolar-disease/q6.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第七題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '7. 容易分心，被周圍的事物影響？',
            image: 'self-test/bipolar-disease/q7.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第八題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '8. 比平時更有精力？',
            image: 'self-test/bipolar-disease/q8.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第九題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '9. 比平時更加外向及熱愛社交，甚至過份熱情，如半夜打電話給朋友？',
            image: 'self-test/bipolar-disease/q9.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第十題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '10. 比平時對性更感興趣',
            image: 'self-test/bipolar-disease/q10.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第十一題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '11. 比平時做多了不尋常的行為，或做了其他人覺得過分、愚蠢或危險的事情',
            image: 'self-test/bipolar-disease/q11.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第十二題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '12. 揮霍金錢，為您或您的家人帶來麻煩？',
            image: 'self-test/bipolar-disease/q12.png',
            answers: [
                {
                    label: "是",
                    answer: "Yes",
                },
                {
                    label: "否",
                    answer: "No",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第十三題',
            title: '您是否曾經於不同時間出現以下情況，並且發覺自己跟平時不同？',
            content: '13. 您是否同時出現兩種或以上12條問題所述的症狀？',
            image: 'self-test/bipolar-disease/q13.png',
            answers: [
                {
                    label: "是",
                    answer: "A",
                },
                {
                    label: "否",
                    answer: "B",
                },
            ]
        },
        {
            type: 'multiple-choice',
            label: '第十四題',
            title: '這些症狀有否為您的工作、家庭、經濟、社交等造成困擾？',
            image: 'self-test/bipolar-disease/q14.png',
            answers: [
                {
                    label: "沒有",
                    answer: "A",
                },
                {
                    label: "輕微",
                    answer: "B",
                },
                {
                    label: "中等",
                    answer: "C",
                },
                {
                    label: "嚴重",
                    answer: "D",
                },
            ]
        },
    ]
};
